import React from "react";
import "./switch-component.style.scss";
export default function SwitchComponent({ state, style = {}, changeState }) {
  return (
    <div
      onClick={() => changeState(!state)}
      style={{ ...style }}
      className={`switch-component ${state ? "switch-on" : ""}`}
    >
      <span></span>
    </div>
  );
}
